<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-16 11:06:36
 * @name: 我的订单
 * @Description: 我的订单
 * @FilePath: \preSaleNafterSaleInside\project\src\views\index\myOrder\myOrderRouter.vue
 * @Author: desktop
-->
<template>
  <div>

  </div>
</template>
<script>
export default {
  name: 'indexMyOrder',  
}
</script>
<style lang="scss" scoped>

</style>